<template>
	<div>
		<div class="Minister-top information uploadPictures">
			<div class="Minister-top-top Ministerbackground">
				<div class="Minister-top-left Minister-top-color">产品图片</div>
			</div>
			<div class="productimgs">
				<div class="fluid container">
					<draggable
							class="list-group"
							tag="ul"
							@start="isDragging = true"
							@end="isDragging = false"
							:list="imgListSelect"
							handle=".list-group-item"
					>
						<li
								class="list-group-item"
								v-for="(element, index) in imgListSelect"
								:key="element"
						>
							<div class="mask" v-if="system == 5 && !isChakan">
								<i
										class="custom-icon el-icon-zoom-in"
										@click="handlePictureCardPreview(element)"
								></i>
								<i
										class="custom-icon el-icon-delete"
										@click="handleRemoveSelect(index)"
								></i>
							</div>
							<div class="badge">
								<img :src="element" alt />
							</div>
						</li>
						<li
								v-if="system == 5 && !isChakan"
								@click="openSelectDialog"
								class="avatar-uploader"
								slot="footer"
						>
							<i data-v-c660ac10 class="el-icon-plus"></i>
						</li>
					</draggable>
				</div>
			</div>

		</div>
		<el-dialog
				:visible.sync="dialogVisibleSelect"
				:modal-append-to-body="false"
				append-to-body
				width="1200px"
				top="6vh"
		>
			<div slot="title" class="dialog-select-img">
				<div class="title-box">选择图片</div>
				<el-button type="primary" @click="openSelectImg">引用图片</el-button>
				<el-button type="primary" @click="lianjiedaoru">链接导入</el-button>
			</div>
<!--			<p>-->
<!--				图片可批量上传，只支持-->
<!--				<span style="color:red;font-weight:bold;"-->
<!--				>JPG/TIFF/JPEG</span-->
<!--				>-->
<!--				格式图片，首选-->
<!--				<span style="color:red;font-weight:bold;">JPEG</span>-->
<!--				格式， 图片的最长边不应低于-->
<!--				<span style="color:red;font-weight:bold;">1600</span>-->
<!--				像素，最长边不得超过-->
<!--				<span style="color:red;font-weight:bold;">10,000</span>-->
<!--				像素，不能包含徽标或水印。商品必须是填满-->
<!--				<span style="color:red;font-weight:bold;">85%</span>-->
<!--				的图片,图片详细标准请参阅Amazon平台要求。-->
<!--			</p>-->

			<draggable
					class="list-group"
					tag="ul"
					@start="isDragging = true"
					@end="isDragging = false"
					:list="imgListUpdate"
					handle=".list-group-item"
			>
				<li class="list-group-item" v-for="(element, index) in imgListUpdate" :key="element.url">
					<div class="mask">
						<i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
						<i class="custom-icon el-icon-delete" @click="handleRemoveSelect2(index, element)"></i>
					</div>
					<div class="badge">
						<img :src="element.url" alt />
					</div>
				</li>
				<el-upload class="upload-demo" ref="dialogSelect" accept="image/jpeg, image/tiff" drag multiple
					:action="action" list-type="picture-card" :on-success="handSuccess" :on-change="handChange"
					:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-error="handleError"
					:on-progress="handleProgress" :headers="customHeaders" :auto-upload="true">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">
						将文件拖到此处，或
						<em>选择图片</em>。只能上传JPG/PNG文件，且不超过2M
					</div>
					<!-- <div class="el-upload__tip" slot="tip">
						只能上传JPG/PNG文件，且不超过2M
					</div> -->
				</el-upload>
				<!-- <div style="margin-top: 10px">
					<div style="display: flex;width: 100%;flex-wrap: wrap">
						<img v-for="(item,index) in lianjieUrlList" :key="index"
							:src="item"
							class="prduct_img"
							alt
						/>
					</div>
					<el-button style="margin-top: 6px" type="primary" @click="lianjiedaoru">链接导入</el-button>
				</div> -->
			</draggable>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleSelect = false"
				>取 消</el-button
				>
				<el-button type="primary" @click="sureImg">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleSee" width="500px" append-to-body >
			<img width="100%" :src="dialogImageUrl" alt />
		</el-dialog>
		<el-dialog :visible.sync="lianjieVisibleSee" width="900px" title="图片链接导入" append-to-body >
			<el-input
					type="textarea"
					placeholder="不同图片链接请用英文逗号隔开"
					v-model="lianjieUrl"
					maxlength="5000"
					show-word-limit
					:disabled="system < 5"
			></el-input>
			<div style="margin-top: 10px;color: red">不同图片链接请用英文逗号隔开</div>
			<span slot="footer" class="dialog-footer">
					<el-button @click="lianjieVisibleSee = false">取 消</el-button>
					<el-button type="primary" @click="sureLianjie">确 定</el-button>
				</span>
		</el-dialog>
		<el-dialog :visible.sync="dialogSelectState" width="90%" top="1vh" class="select-img-box"
			:before-close="closeSelectImg" :modal-append-to-body="false"
			append-to-body>
			<div class="select-row" slot="title">
				<div class="select-item">
					<div class="label">店铺关键字</div>
					<el-input v-model="searchTerm" placeholder="请输入店铺关键字" filterable>
					</el-input>
				</div>
				<div class="select-item">
					<div class="label">店铺链接</div>
					<el-input v-model="shopLink" placeholder="请输入店铺链接" filterable>
					</el-input>
				</div>
				<div class="select-item">
					<div class="label">sku</div>
					<el-input v-model="sku" placeholder="请输入sku，多个sku使用英文逗号隔开" filterable>
					</el-input>
				</div>
				<el-button type="primary" @click="searchImage">查询</el-button>
				<el-button type="primary" @click="downLoadImg">下载图片</el-button>
			</div>
			<div class="box1" v-loading="updImageState">
				<div class="image-title">
					主图：
				</div>
				<div class="image-box">
					<SelectableImageBox @updActiveList="activeMain = $event" :list="mainImages" :activeList="activeMain" :otherActiveList="activeOther" @updOtherActiveList="updOtherActiveList" size="150" type="main"></SelectableImageBox>
				</div>
				<el-divider></el-divider>
				<div class="image-title">其他：</div>
				<div class="image-box">
					<SelectableImageBox @updActiveList="activeOther = $event" :list="otherImages" :activeList="activeOther" size="150" type="other">
					</SelectableImageBox>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" v-loading="updImageState">
				<el-button @click="closeSelectImg">取 消</el-button>
				<el-button type="primary" @click="submitSelectImg">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import { ajaxPost, Baseurl } from '../../../../api/api/api'
	import JSZip from 'jszip';
	import { saveAs } from 'file-saver';
	import SelectableImageBox from '@/components/SelectableImageBox';
	import Axios from "axios";
	export default {
		components: {
			draggable,
			SelectableImageBox
		},
		props: {
			pageType: {
				type: String,
				default() {
					return ''
				},
			},
		},
		created() {
			this.system = JSON.parse(localStorage.getItem('role')).system
		},
		data() {
			return {
				//是否为查看
				isChakan:false,
				lianjieUrl:'',
				lianjieUrlList:[],
				lianjieVisibleSee:false,
				system:5,
				action: Baseurl + 'imageController/uploadImage',
				dialogVisibleSelect: false,
				dialogVisibleSee: false,
				dialogImageUrl: '',
				imgList: '',
				imgListUpdate: [],
				//页面展示的图片
				imgListSelect: [],
				isDragging: false,
				customHeaders: { token: localStorage.getItem('token') },
				updateImageList: [],
				arr: [],
				mainSelectImgMap:{},
				otherSelectImgMap:{},
				activeOther:[],
				activeMain:[],
				dialogSelectState: false,
				updImageState: false,
				searchTerm: '',
				shopLink: '',
				sku: '',
				otherImages: [],
				mainImages: [],
				selectImgMap:{}, // 已经选择的图片
			}
		},
		methods: {
			openSelectDialog(){
				this.imgListUpdate = this.imgListSelect.map(item => {
					return {
						url: item,
						response: {
							data: item
						}
					}
				})
				this.dialogVisibleSelect = true;
			},
			updOtherActiveList(e){
				this.activeOther = e;

			},
			closeSelectImg(){
				this.dialogSelectState = false;
			},
			openSelectImg(){
				this.activeMain = Object.keys(this.mainSelectImgMap);
				this.activeOther = Object.keys(this.otherSelectImgMap);
				this.dialogSelectState = true;
			},
			async downLoadImg(){
				const arr = [...this.activeMain, ...this.activeOther];
				if (arr.length === 0) {
					this.$message.error('至少选择一张图片');
					return
				}
				// for(let i = 0; i < )

				if(arr.length == 1){
					const link = document.createElement('a');
					link.href = arr[0]; // 设置图片的 URL 作为下载链接

					// 如果是跨域的图片，可以使用 Blob 来绕过直接跳转
					if (arr[0]) {
						fetch(arr[0]).then(response => response.blob()) // 转换为 Blob 数据
							.then(blob => {
								// 创建一个 URL 对象，表示图片的 Blob 数据
								const blobUrl = URL.createObjectURL(blob);
								link.href = blobUrl;  // 使用 Blob URL 设置 href
								link.download = this.searchTerm + '.jpg'; // 设置下载文件的名称
								link.click(); // 模拟点击下载
								URL.revokeObjectURL(blobUrl); // 释放创建的 URL 对象
							})
							.catch(error => {
								console.error('下载图片失败:', error);
							});
					}
				}else{
					const zip = new JSZip();  // 创建一个新的 ZIP 实例
					const folder = zip.folder(this.searchTerm); // 在 ZIP 中创建一个文件夹

					// 遍历图片数组并下载图片
					for (let i = 0; i < arr.length; i++) {
						const imageUrl = arr[i];

						try {
							const response = await fetch(imageUrl); // 请求图片
							const blob = await response.blob();  // 获取图片 Blob 数据

							// 将图片添加到 ZIP 文件夹中
							folder.file(`${this.searchTerm}-${i + 1}.jpg`, blob);
						} catch (error) {
							console.error('图片下载失败:', error);
						}
					}

					// 生成 ZIP 文件并触发下载
					zip.generateAsync({ type: 'blob' }).then((content) => {
						saveAs(content, this.searchTerm + '.zip');  // 触发下载 ZIP 文件
					});
				}
			},
			searchImage(){
				if(!this.searchTerm && !this.shopLink && !this.sku){
					this.$message.warning('请输入其中一项')
					return
				}
				const params = {}
				if(this.searchTerm){
					params['searchTerm'] = this.searchTerm;
				}
				if(this.shopLink){
					params['shopLink'] = this.shopLink;
				}
				if(this.sku){
					params['skus'] = this.sku.split(',');
				}
				this.mainImages = [];
				this.otherImages = [];
				ajaxPost(Baseurl + 'amazonProductCrawl/getPriceAndImageBySearchTerm', params).then((response)=>{
					if (response.status == 200 && response.data && response.data.code == 200) {
						const data = response.data.data;
						if(data.length == 0){
							this.$message.warning('没有查询到数据')
						}
						const mainImages = [];
						const obj = {};
						const otherImages = [];
						for(let i = 0; i < data.length; i++){
							let imageList = data[i]['ozonImageList'] ? data[i]['ozonImageList'] : [];
							imageList = imageList.filter(item => item);
							if(imageList.length > 0){
								const mainItem = {
									src: imageList[0],
									otherSrc: imageList.slice(1),
									price: data[i]['price'],
									currency: data[i]['currency']
								}
								if(!obj[mainItem['src']]){
									mainImages.push(mainItem);
									obj[mainItem['src']] = 1;
								}
								obj[mainItem['src']] ++;
								const citrus = imageList.slice(1); 
								otherImages.push(...citrus)
							}
						}
						this.mainImages = mainImages;
						this.otherImages = [...new Set(otherImages)];
					}
				})
			},
			async submitSelectImg(){
				const arr = [...this.activeMain, ...this.activeOther];
				if(arr.length === 0){
					this.$message.error('至少选择一张图片');
				}
				this.updImageState = true;
				const results = [];
				for(let i = 0; i < arr.length; i++){
					if(this.selectImgMap[arr[i]]){
						continue
					}
					try {
						// 下载图片
						const response = await fetch(arr[i]);
						const blob = await response.blob();  // 将图片转为 Blob 对象


						// 创建 FormData 对象
						const formData = new FormData();
						formData.append('file', blob, 'image.jpg');  // 'file' 是后端接收的字段名

						// 上传文件
						const res = await Axios({
							url: Baseurl + 'xgImage/uploadImage',
							method: "post",
							data: formData,
							headers: {
								"Content-Type": "multipart/form-data",
								"token": localStorage.getItem('token'),
							},
						});
						

						// 上传成功的处理
						if (res.status === 200 && res.data.code === 200) {
							// this.getPageData();
							// 上传成功后的操作
							results.push({
								url: res.data.data,
								response: {
									data: res.data.data
								}
							});
							this.$set(this.selectImgMap, arr[i], res.data.data)
						} else {
							this.$message.error("上传失败！");
						}
					} catch (error) {
						this.$message.error("图片下载或上传失败！");
					}
					if(this.activeMain.includes(arr[i])){
						this.$set(this.mainSelectImgMap, arr[i], 1);
					}
					if (this.activeOther.includes(arr[i])) {
						this.$set(this.otherSelectImgMap, arr[i], 1);
					}
				}
				this.arr = true;
				this.updImageState = false;
				this.dialogSelectState = false;
				this.imgListUpdate.push(...results);
			},
			addImgList(imgArr) {
				this.imgListSelect = imgArr
				this.$emit('ImgList', this.imgListSelect)
			},
			// 父组件添加图片相应
			addImg(file) {
				this.imgListSelect.push(file)
				this.$emit('ImgList', this.imgListSelect)
			},
			sureImg() {
				this.submitUpload()
				if(this.arr == true) {
					// this.$message.success('上传成功')
					let ss = this.imgListUpdate.map(item=>{
						return item.response.data
					})
					this.imgListSelect = this.imgListUpdate.filter((item) => item.response && item.response.data).map(item => item.response.data)
					this.imgListUpdate = []
					this.lianjieUrlList = []
					this.$refs.dialogSelect.clearFiles()
					this.dialogVisibleSelect = false
					this.$emit('ImgList', this.imgListSelect)
				}
			},
			handleProgress(event, file, fileList) {
			},
			submitUpload() {
				this.$refs.dialogSelect.submit()
			},
			handSuccess(res, file, fileList) {
				if(res.code == 200){
					const item = {
						url: res.data,
						response: {
							data: res.data
						}
					}
					this.imgListUpdate.push(item);
				}
				this.arr = fileList.every((item) => item.response && item.response.code === 200)
				if (this.arr == true) {
					this.imgList = this.imgListUpdate.map((item) => item.response && item.response.data)
					this.$message.success('上传成功')
				} else {
					for (let i = 0; i < fileList.length; i++){
						if (fileList[i]['status'] == 'success' && res.code == 500){
							this.$nextTick(()=>{
								this.$message.error(res.data)
							})
						}
					}
				}
			},
			handChange(file, fileList) {
				// this.imgListUpdate = fileList
			},
			handleAvatarSuccess(response, file, fileList) {
				this.$message.success('上传成功')
				this.imgListUpdate = fileList
			},
			uploading(msg) {
				this.$message.success(msg)
			},
			handleError(err, file, fileList) {
				this.$message.error(err)
			},
			handlePictureCardPreview(file) {
				let imageUrl = ''
				if (Object.prototype.toString.call(file) === '[object Object]') {
					imageUrl = file.response.data
				} else {
					imageUrl = file
				}
				this.dialogImageUrl = imageUrl
				this.dialogVisibleSee = true
			},
			handleRemove(file, fileList) {
				this.imgListUpdate = fileList
			},
			handleRemoveSelect(index) {
				this.imgListSelect.splice(index, 1)
				this.$emit('ImgList', this.imgListSelect)
			},
			handleRemoveSelect2(index) {
				this.$nextTick(() => {
					for(let k in this.selectImgMap){
						if(this.selectImgMap[k] == item.url){
							this.$delete(this.selectImgMap, k)
							const mainIndex = this.activeMain.indexOf(k);
							if (mainIndex != -1) {
								this.activeMain.splice(mainIndex, 1);
								this.$delete(this.mainSelectImgMap, k)
								break
							}
							const otherIndex = this.activeOther.indexOf(k);
							if (otherIndex != -1) {
								this.activeOther.splice(otherIndex, 1);
								this.$delete(this.otherSelectImgMap, k)
								break
							}
							break
						}
					}
					let imgInfo = this.imgListUpdate[index].response.data
					let deleteImage = (imgInfo.lastIndexOf('/') + 1)
					deleteImage = imgInfo.substring(deleteImage, imgInfo.length)
					let deleteFiles = []
					deleteFiles.push(deleteImage)
					this.imgListUpdate.splice(index, 1)
					// let API = Baseurl + 'xgImage/deleteImage'
					// ajaxPost(API, { objectNames: deleteFiles })
					// 	.then((res) => {
					// 		if (res.data.code == 200) {
					// 			this.$message.success('删除图片成功!')
					// 		} else {
					// 			this.$message.error(res.data.data || '删除图片失败!')
					// 		}
					// 	})
					// 	.catch((e) => {
					// 		console.log(e)
					// 	})
					deleteFiles = []
				})
			},
			downloadImgs() {
				this.$emit('downloadImgs')
			},
			//变体增加图片
			biantiaddImgList(imageList){
				this.imgListSelect = this.imgListSelect.concat(imageList)
				this.$emit('ImgList', this.imgListSelect)
			},
			lianjiedaoru(){
				this.lianjieUrl = ''
				let url = ''
				if (this.lianjieUrlList.length > 0){
					for (let i = 0; i < this.lianjieUrlList.length; i++) {
						url = url + this.lianjieUrlList[i] +','
					}
				}
				this.lianjieUrl = url.slice(0,-1)
				this.lianjieVisibleSee = true
			},
			sureLianjie(){
				this.lianjieVisibleSee = false
				if (this.lianjieUrl){
					const urls = this.lianjieUrl.split(',').map(item => {
						return {
							url: item,
							response: {
								data: item
							}
						}
					})
					this.imgListUpdate = [...this.imgListUpdate, ... urls];
					this.arr = true;
					// this.imgListSelect.map(item => {
					// 	return {
					// 		url: item,
					// 		response: {
					// 			data: item
					// 		}
					// 	}
					// })
					// this.lianjieUrlList = this.lianjieUrl.split(',')
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	::v-deep .upload-demo {
		.el-upload--picture-card {
			line-height: initial;

			.el-upload-dragger {
				width: 100%;
				height: 100%;
				border: none;
			}
		}
	}
	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;

		.Ministerbackground {
			background: #d7f0dbff;
		}
		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 80px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}
		}
		.information_content {
			width: calc(100% - 22px);
			overflow: hidden;
			padding: 10px 10px;
			border: 1px solid rgba(168,168,168,0.8);
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			border-top: none !important;
			margin-bottom: 15px;

			.information_Mandarin {
				overflow: hidden;
				// margin-left: 4%;
				display: flex;
				justify-content: space-between;

				ul {
					max-width: 1450px;
					flex: 1;
					display: flex;

					li {
						width: 90px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						// float: left;
						cursor: pointer;
					}
					.liactive {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.information_tips {
				line-height: 50px;
				margin-left: 10%;
				color: #f89a9a;
				font-size: 16px;
			}
			.information_input {
				overflow: hidden;
				position: relative;
				.region {
					width: 80px;
					height: 80px;
					background: rgba(0, 0, 0, 0);
					// background: red;
					position: absolute;
					left: 0px;
					top: 50px;
				}
				.information_Title {
					width: 8%;
					overflow: hidden;
					color: #7d7171;
					text-align: right;
					float: left;
					line-height: 33px;
					margin-right: 1%;
					font-weight: bold;
					user-select: none;
					.tips {
						color: red;
					}
				}
				.input_el {
					width: 88%;
					float: left;

					.Preservation {
						float: right;
						padding: 10px 10px;
						background: #73ade9;
						color: #fff;
						margin-top: 5px;
						border-radius: 5px;
					}
				}
			}
		}
	}
	.uploadPictures {
		/deep/ .el-upload-list__item {
			width: 178px;
			height: 178px;
		}
		/deep/ .el-upload--picture-card {
			width: 178px;
			height: 178px;
			line-height: 178px;
			padding: 0 20px;
		}
		/deep/ .selectUpload {
			// .el-upload.el-upload--picture-card,
			.el-upload-list__item-status-label {
				display: none;
			}
		}
		/deep/ .el-dialog__body {
			word-break: break-word;
		}
		.flip-list-move {
			transition: transform 0.5s;
		}
		.no-move {
			transition: transform 0s;
		}
		.ghost {
			opacity: 0.5;
			background: #c8ebfb;
		}
		
		.showImg {
			width: 148px;
			float: left;
			margin-right: 15px;
		}
		.avatar-uploader {
			width: 178px;
			height: 178px;
			background-color: #fbfdff;
			border: 1px dashed #c0ccda;
			border-radius: 6px;
			box-sizing: border-box;
			cursor: pointer;
			text-align: center;
			line-height: 178px;
			font-size: 40px;
			&:hover {
				border-color: #409eff;
			}
		}
	}

	.productimgs {
		width: calc(100% - 22px);
		overflow: hidden;
		padding: 10px 10px;
		border: 1px solid rgba(168,168,168,0.8);
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		border-top: none !important;
		margin-bottom: 15px;
	}
	.prduct_img{
		height: 130px;
		width: 130px;
		margin: 0 10px 10px 0;
	}

	.dialog-select-img{
		display: flex;
		align-items: center;
		.title-box{
			font-size: 18px;
			margin-right: 10px;
		}
	}

	.box1{
		.image-title{
			font-size: 16px;
			margin-bottom: 8px;
		}
		.image-box{
			height: 380px;
			overflow-y: auto;
		}
	}
	.select-img-box{
		/deep/ .el-dialog__body{
			padding: 5px 10px;
			max-height: none;
		}
	}
	.select-row{
		display: flex;
		align-items: center;
		.select-item{
			display: flex;
			align-items: center;
			margin-right: 10px;
			.label{
				margin-right: 5px;
				// flex: 1;
				white-space: nowrap;
			}
		}
		.tip{
			font-size: 16px;
			margin-left: 10px;
		}
	}
	.list-group {
			display: flex;
			flex-wrap: wrap;
			overflow: hidden;
			/deep/ .list-group-item {
				width: 178px;
				height: 178px;
				background-color: #fbfdff;
				border: 1px dashed #c0ccda;
				border-radius: 6px;
				box-sizing: border-box;
				cursor: pointer;
				margin-right: 10px;
				margin-bottom: 10px;
				// float: left;
				position: relative;
				overflow: hidden;

				.mask {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					background: rgba(0, 0, 0, 0.5);
					position: absolute;
					top: 0;
					left: 0;
					opacity: 0;
					transition-duration: 0.5s;

					.custom-icon {
						font-size: 20px;
						margin: 0 8px;
						color: #fff;
					}
				}

				&:hover .mask {
					opacity: 1;
					border-color: #409eff;
				}
			}

			.list-group-item img {
				width: 100%;
				height: 100%;
			}
		}
		/deep/ .upload-demo {
			width: 178px;
			height: 178px;
			.el-upload-list--picture-card.el-upload-list {
				display: none;
			}
			.el-upload{
				width: 178px;
				height: 178px;
			}
			

			.el-upload--picture-card {
				line-height: initial;

				.el-upload-dragger {
					width: 100%;
					height: 100%;
					border: none;
				}
			}
		}
		.el-divider{
		margin: 10px 0;
	}
</style>
